<template>
  <div class="root-container">
    <!-- 左侧菜单栏 -->
    <div class="sidebar" :class="{'is-collapsed': isCollapse}">
      <div class="logo-area">
        <img src="../assets/img/HPC.png" alt="Logo" class="logo-img">
        <span class="logo-text" v-show="!isCollapse">企业能碳管控平台</span>
      </div>
      
      <el-menu
        default-active="1"
        class="el-menu-vertical"
        background-color="#1a2332"
        text-color="#b0c4de"
        active-text-color="#00d4ff"
        :collapse="isCollapse">
        
        <el-menu-item index="1" @click="currentView = 'home'">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        
        <el-menu-item index="2" @click="currentView = 'user'">
          <i class="el-icon-monitor"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        
        <el-menu-item index="3" @click="currentView = 'carbon'">
          <i class="el-icon-s-data"></i>
          <span slot="title">设备管理</span>
        </el-menu-item>

        <el-menu-item index="3" @click="currentView = 'carbon'">
          <i class="el-icon-s-data"></i>
          <span slot="title">预警管理</span>
        </el-menu-item>
        <!-- 更多菜单项可以根据需要添加 -->
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span slot="title">系统设置</span>
          </template>
          <el-menu-item index="4-1" @click="currentView = 'user'">用户管理</el-menu-item>
          <el-menu-item index="4-2">角色权限</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <!-- 右侧主内容区 -->
    <div class="main-wrapper">
      <!-- 顶部导航栏 -->
      <div class="top-navbar">
        <div class="nav-left">
          <i class="el-icon-s-fold toggle-icon" @click="isCollapse = !isCollapse"></i>
          <div class="company-selector">
            <el-select v-model="selectedCompany" placeholder="请选择公司" size="small" @change="handleCompanyChange">
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" class="switch-btn" @click="handleCompanyChange">切换</el-button>
          </div>
        </div>
        
        <div class="nav-right">
          <div class="user-profile">
            <el-avatar size="small" icon="el-icon-user-solid"></el-avatar>
            <span class="username">{{ username }}</span>
            <i class="el-icon-switch-button logout-icon" @click="logout" title="退出登录"></i>
          </div>
        </div>
      </div>

      <!-- 内容展示区 -->
      <div class="content-area">
        <!-- 内容展示区 -->
        <test-component v-if="currentView === 'home'" :company-id="selectedCompany"></test-component>
        
        <!-- 用户管理模块 -->
        <user-component v-else-if="currentView === 'user'" :company-id="selectedCompany"></user-component>
        
        <!-- 其他视图占位 -->
        <div v-else-if="currentView === 'monitor'" class="placeholder-view">
          <h2>数据监控模块</h2>
          <p>当前选中公司ID: {{ selectedCompany }}</p>
        </div>
        
        <div v-else-if="currentView === 'carbon'" class="placeholder-view">
          <h2>碳排放模块</h2>
          <p>当前选中公司ID: {{ selectedCompany }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TestComponent from './test.vue';
import UserComponent from './user.vue';
import axios from 'axios';

export default {
  name: 'Root',
  components: {
    TestComponent,
    UserComponent
  },
  data() {
    return {
      isCollapse: false,
      currentView: 'home',
      selectedCompany: '',
      companyList: [],
      username: '管理员'
    };
  },
  created() {
    this.fetchCompanyList();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.user_name) {
      this.username = user.user_name;
    }
  },
  methods: {
    fetchCompanyList() {
      // 模拟获取公司列表，实际应调用接口
      // axios.get('/otherApi/manager/getallcompany/').then(...)
      // 这里先使用模拟数据
      this.companyList = [
        { id: '1', name: '安科瑞电气股份有限公司' },
        { id: '2', name: '华兰生物工程股份有限公司' },
        { id: '3', name: '江苏金风科技股份有限公司' }
      ];
      
      // 默认选中第一个
      if (this.companyList.length > 0) {
        this.selectedCompany = this.companyList[0].id;
      }
      
      // 尝试从接口获取真实数据
      axios.get('/otherApi/manager/getallcompany/')
        .then(res => {
          if (res.data && res.data.data) {
            this.companyList = res.data.data.map(item => ({
              id: item.company_id,
              name: item.company_name
            }));
            if (this.companyList.length > 0 && !this.selectedCompany) {
              this.selectedCompany = this.companyList[0].id;
            }
          }
        })
        .catch(err => {
          console.error('获取公司列表失败', err);
        });
    },
    handleCompanyChange() {
      const company = this.companyList.find(c => c.id === this.selectedCompany);
      if (company) {
        this.$message.success(`已切换到公司: ${company.name}`);
      }
      // 这里可以触发子组件更新或其他逻辑
    },
    logout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('user');
        this.$router.push('/');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.root-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #0a0e1a;
  overflow: hidden;
}

/* 左侧菜单样式 */
.sidebar {
  width: 200px;
  height: 100%;
  background-color: #1a2332;
  border-right: 1px solid rgba(0, 212, 255, 0.1);
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
  overflow: hidden;
}

.sidebar.is-collapsed {
  width: 64px;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.logo-area {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: #131924;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
}

.sidebar.is-collapsed .logo-area {
  padding: 0;
  justify-content: center;
}

.logo-img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.sidebar.is-collapsed .logo-img {
  margin-right: 0;
}

.logo-text {
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  color: #00d4ff;
}

.el-menu-vertical {
  border-right: none;
  flex: 1;
}

/* 右侧主内容区样式 */
.main-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航栏样式 */
.top-navbar {
  height: 60px;
  background-color: #1a2332;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.toggle-icon {
  font-size: 24px;
  color: #b0c4de;
  cursor: pointer;
}

.toggle-icon:hover {
  color: #00d4ff;
}

.company-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch-btn {
  background-color: #00d4ff;
  border-color: #00d4ff;
}

.nav-right {
  display: flex;
  align-items: center;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
}

.username {
  font-size: 14px;
  color: #b0c4de;
}

.logout-icon {
  font-size: 18px;
  color: #ff6b6b;
  cursor: pointer;
  margin-left: 10px;
}

.logout-icon:hover {
  color: #ff4757;
}

/* 内容展示区样式 */
.content-area {
  flex: 1;
  overflow-y: auto;
  position: relative;
  background-color: #0a0e1a;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 0; /* 移除顶部间距，实现贴合 */
}

/* 强制缩放内容以适应屏幕，确保无滚动条 */
::v-deep .content-area > * {
  transform: scale(0.85);
  transform-origin: top center;
  width: 100vw;
  height: auto !important;
  min-height: 100vh;
  flex-shrink: 0;
  border-radius: 0;
  box-shadow: none;
  margin-top: -20px;
}

.placeholder-view {
  padding: 40px;
  color: #fff;
  text-align: center;
}

/* 覆盖 Element UI 样式以适应暗色主题 */
::v-deep .el-select .el-input__inner {
  background-color: #0d141e;
  border-color: #2c3e50;
  color: #fff;
}

::v-deep .el-menu-item:hover {
  background-color: #2c3e50 !important;
}

::v-deep .el-menu-item.is-active {
  background-color: rgba(0, 212, 255, 0.1) !important;
  border-right: 3px solid #00d4ff;
}
</style>


// WEBPACK FOOTER //
// src/views/root.vue